<template>
  <div>
    <!-- <a v-if="!isWeiXin()" style=" width: 100%; height: 100%; left: 0; top: 0; transform: translate(0, 0); padding: 0; " id="public-web-jump-button" href="javascript:" class="weui-btn weui-btn_primary weui-btn_loading" @click="openWx(url)" > -->
    <a v-if="!isWeiXin()" style=" width: 100%; height: 100%; left: 0; top: 0; transform: translate(0, 0); padding: 0; " id="public-web-jump-button" href="javascript:" class="weui-btn weui-btn_primary weui-btn_loading" @click="initOpenWx()" >
      <!-- <span id="public-web-jump-button-loading" class="weui-primary-loading_transparent">
            <i class="weui-primary-loading__dot"></i></span>
          打开小程序 -->
      <img
        style="height: auto; width: 100%"
        src="https://cippe-1302098519.cos.ap-beijing.myqcloud.com/public/icon/program.jpg"
      />
    </a>
    <div v-else class="test-position">
      <wx-open-launch-weapp
        id="launch-btn"
        username="gh_6a4787ccc143"
        path="/pages/index/index.html"
      >
        <!-- <script type="text/wxtag-template"> -->
          <!-- <button class='btn'>打开小程序</button> -->
          <img style="height:auto;width:100%" src="https://cippe-1302098519.cos.ap-beijing.myqcloud.com/public/icon/program.jpg" />
        <!-- </script> -->
      </wx-open-launch-weapp>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
// import { reqOpenWx } from "../../api";
export default {
  data(){
    return{
      url:''
    }
  },
  created() {
    let wxJs = document.createElement("script");
    wxJs.type = "text/javascript";
    wxJs.src = "https://res.wx.qq.com/open/js/jweixin-1.6.0.js";
    wxJs.onload = this.wxmini;
    document.head.appendChild(wxJs);
  },
  // beforeMount(){
  //   let that = this
  //   axios.get('https://s.whte.cn/cippe/openWx')
  //   .then(function (response) {
  //     console.log('response', response.data.url);
  //     console.log(that);
  //     that.url = response.data.url
  //     that.openWx(response.data.url)
  //   })
  //   .catch(function (error) {
  //     console.log(error);
  //   });
  // },
  methods:{
    async openWx(url){//跳转到小程序
      console.log(111);
      // location.href = 'weixin://dl/business/?t=lDX88LdX9Ai'
      // location.href = '#小程序://cippe/V9zbskWY0PVkK6y'
      location.href = url
    },
    isWeiXin(){
      var ua = window.navigator.userAgent.toLowerCase();
        if(ua.match(/MicroMessenger/i) == 'micromessenger'){
            return true;
        }else{
            return false;
        }
    },
    async initOpenWx(){
      // let url = window.location.href
      // if (!(url.slice(0,5)==='https')) {
      //   this.appHerf('https://e.cippe.com.cn/#/home')
      //   return
      // }
      // const response = await reqOpenWx()
      axios.get('https://s.whte.cn/cippe/openWx')
      .then(function (response) {
        console.log('response', response.data.url);
        this.url = response.data.url
        this.openWx(response.data.url)
      })
      .catch(function (error) {
        console.log(error);
      });
      // const url1 = response.url
      // this.url = url1
      // this.openWx(url1)
      // wx.config({
      //   appId: response.data.appId,
      //   debug: false,
      //   timestamp: response.data.timestamp,
      //   nonceStr: response.data.nonceStr,
      //   signature:response.data.signature,
      //   jsApiList: [
      //     "onMenuShareAppMessage",
      //     "onMenuShareTimeline",
      //     "updateAppMessageShareData",
      //     "updateTimelineShareData",
      //     "checkJsApi",
      //   ],
      //   openTagList:["wx-open-launch-weapp"], // 可选，需要使用的开放标签列表，例如[‘wx-open-launch-weapp’]
      // });
      // wx.ready(function () {
      //   wx.error(function () {
      //     // config信息验证失败会执行error函数，如签名过期导致验证失败，具体错误信息可以打开config的debug模式查看，也可以在返回的res参数中查看，对于SPA可以在这里更新签名。
      //   });
      // })
    }

  }
};
</script>

<style>
</style>